var _require = require('preact'),
    h = _require.h;

module.exports = function (props) {
  return h(
    "div",
    { "class": "uppy-Provider-loading" },
    h(
      "span",
      null,
      "Loading..."
    )
  );
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@uppy/provider-views/lib/Loader.js
// module id = 1381
// module chunks = 0